<div id="sidebar">
  <div class="logo-container">
    <a class="logo" [href]="URL_HOME" matRipple>
      <div>
        <img src="/assets/img/logo-qr.svg" alt="" />
      </div>
    </a>
    <div class="brand-name subheading-01-semi-bold">QR Solutions</div>
  </div>
</div>

<!-- Botón: Menú de cuenta -->
<ng-container>
  <qr-button
    [config]="accountButton"
    (click)="visibleMenuUser = !visibleMenuUser"
    class="account-button"
  ></qr-button>
</ng-container>

<div class="user-menu" *ngIf="visibleMenuUser">
  <div class="name-user">
    <div class="avatar">
      <img src="assets/img/default.png" alt="" />
    </div>
    <p class="subheading-01-semi-bold">{{ this.userDisplayName }}</p>
  </div>

  <div class="currency">
    <span class="paragraph-02-regular">Moneda</span>
    <div class="currency-switch">
      <qr-toggle
        [config]="toggleCurrency"
        (change)="toggleCurrencyChange($event)"
      ></qr-toggle>
    </div>
  </div>

  <ul class="buttons-list">
    <a [href]="URL_CONFIGURATION" *ngIf="isConfigVisible()">
      <li matRipple>
        <div class="icon">
          <qr-icon [name]="ICON_SETTINGS" [color]="COLOR_GREY_400"></qr-icon>
        </div>
        <span class="subheading-01-semi-bold">Configuración</span>
      </li>
    </a>

    <a [href]="URL_SUPPORT">
      <li matRipple>
        <div class="icon">
          <qr-icon [name]="ICON_SUPPORT" [color]="COLOR_GREY_400"></qr-icon>
        </div>
        <span class="subheading-01-semi-bold">Ayuda y soporte</span>
      </li>
    </a>
    <li (click)="logout()" matRipple>
      <div class="icon">
        <qr-icon [name]="ICON_LOGOUT" [color]="COLOR_GREY_400"></qr-icon>
      </div>
      <span class="subheading-01-semi-bold">Cerrar sesión</span>
    </li>
  </ul>
</div>

<div id="main-container">
  <router-outlet></router-outlet>
</div>

<ng-template #skeletonLoader>
  <qr-skeleton-loader id="sk-sidebar"></qr-skeleton-loader>
</ng-template>
